import {DisplaySize, Placement} from 'common/components/tooltip/types';
import {TooltipAttrs} from 'common/components/tooltip/types';
import {ChartType} from 'common/report/constants';
import {AnalysisType} from 'common/report/insights/util/types';
import pieSvg from 'common/assets/images/charts/pie.svg';
import barSvg from 'common/assets/images/charts/bar.svg';
import lineSvg from 'common/assets/images/charts/line.svg';
import stackedBarSvg from 'common/assets/images/charts/stacked-bar.svg';
import stackedLineSvg from 'common/assets/images/charts/stacked-line.svg';
import rollingLineSvg from 'common/assets/images/charts/rolling-line.svg';
import rollingStackedLineSvg from 'common/assets/images/charts/rolling-stacked-line.svg';
import cumulativeLineSvg from 'common/assets/images/charts/cumulative-line.svg';
import cumulativeStackedLineSvg from 'common/assets/images/charts/cumulative-stacked-line.svg';
import logarithmicBarSvg from 'common/assets/images/charts/logarithmic-bar.svg';
import logarithmicLineSvg from 'common/assets/images/charts/logarithmic-line.svg';
import logarithmicStackedBarSvg from 'common/assets/images/charts/logarithmic-stacked-bar.svg';
import logarithmicStackedLineSvg from 'common/assets/images/charts/logarithmic-stacked-line.svg';
import {TableToggleableMetrics} from 'common/report/funnels/models/constants';

const commonTooltipAttrs = {
  placement: Placement.Left,
  size: DisplaySize.Small,
};

// Helper generators to keep things DRY
function linearTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: `Linear is the standard calculation of counts over time.`,
    ...commonTooltipAttrs,
  };
}

function rollingTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: `Rolling smooths trends by calculating the average value over past periods.`,
    ...commonTooltipAttrs,
  };
}

function logarithmicTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: `Logarithmic nonlinear scale is best used for  wide ranges of values.`,
    ...commonTooltipAttrs,
  };
}

function cumulativeTooltipAttrs(imageSrc) {
  return {
    'image-src': imageSrc,
    text: `Cumulative adds each new period’s value to the sum of previous periods.`,
    ...commonTooltipAttrs,
  };
}
// end helpers

type TooltipByAnalysisTypeAndChartType = {
  [key in AnalysisType]: {
    [key in ChartType]?: TooltipAttrs;
  };
};

export const DEFAULT_STEPS_TABLE_COLUMNS = {
  [TableToggleableMetrics.ConvFirstStep]: false,
  [TableToggleableMetrics.ConvPrevStep]: true,
  [TableToggleableMetrics.Count]: true,
  [TableToggleableMetrics.StatSig]: true,
  [TableToggleableMetrics.TimeFirstStep]: false,
  [TableToggleableMetrics.TimePrevStep]: true,
};

export const ANALYSIS_TYPE_TOOLTIPS: TooltipByAnalysisTypeAndChartType = {
  [AnalysisType.Linear]: {
    [ChartType.Line]: linearTooltipAttrs(lineSvg),
    [ChartType.Bar]: linearTooltipAttrs(barSvg),
    [ChartType.StackedBar]: linearTooltipAttrs(stackedBarSvg),
    [ChartType.StackedLine]: linearTooltipAttrs(stackedLineSvg),
    [ChartType.Pie]: linearTooltipAttrs(pieSvg),
  },
  [AnalysisType.Rolling]: {
    [ChartType.Line]: rollingTooltipAttrs(rollingLineSvg),
    [ChartType.StackedLine]: rollingTooltipAttrs(rollingStackedLineSvg),
  },
  [AnalysisType.Logarithmic]: {
    [ChartType.Line]: logarithmicTooltipAttrs(logarithmicLineSvg),
    [ChartType.Bar]: logarithmicTooltipAttrs(logarithmicBarSvg),
    [ChartType.StackedBar]: logarithmicTooltipAttrs(logarithmicStackedBarSvg),
    [ChartType.StackedLine]: logarithmicTooltipAttrs(logarithmicStackedLineSvg),
  },
  [AnalysisType.Cumulative]: {
    [ChartType.Line]: cumulativeTooltipAttrs(cumulativeLineSvg),
    [ChartType.StackedLine]: cumulativeTooltipAttrs(cumulativeStackedLineSvg),
  },
};
